module.exports = __webpack_public_path__ + "img/gettyimages-107402021.bb79e464.jpg";